import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'

export default function PrivacyPage() {
  const { t } = useTranslation()
  return (
    <main className="max-w-2xl mx-auto px-4 py-10 pb-32">
      <Link to="/" className="inline-flex items-center min-h-[48px] px-2 text-primary-text hover:underline mb-6">
        ← {t('privacy.back')}
      </Link>
      <h1 className="text-2xl font-bold text-fg mb-6">{t('privacy.title')}</h1>

      <section className="space-y-4 text-muted text-base leading-relaxed">
        <p>
          <Trans i18nKey="privacy.intro" components={{ b: <strong /> }} />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('privacy.deviceTitle')}</h2>
        <p>
          <Trans i18nKey="privacy.deviceBody" components={{ b: <strong /> }} />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('privacy.analyticsTitle')}</h2>
        <p>
          <Trans i18nKey="privacy.analyticsBody" components={{ b: <strong /> }} />
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>{t('privacy.analyticsItem1')}</li>
          <li>{t('privacy.analyticsItem2')}</li>
          <li>{t('privacy.analyticsItem3')}</li>
        </ul>
        <p>
          <Trans
            i18nKey="privacy.analyticsFooter"
            components={{ settingsLink: <Link to="/settings" className="text-primary-text underline" /> }}
          />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('privacy.cookiesTitle')}</h2>
        <p>
          <Trans i18nKey="privacy.cookiesBody" components={{ b: <strong /> }} />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('privacy.errorsTitle')}</h2>
        <p>
          <Trans i18nKey="privacy.errorsBody" components={{ b: <strong /> }} />
        </p>

        <h2 className="text-lg font-semibold text-fg">{t('privacy.contactTitle')}</h2>
        <p>
          {t('privacy.contactBody')}
        </p>
      </section>
    </main>
  )
}
